import { render, staticRenderFns } from "./HomeContentBlockFlightGorilla.vue?vue&type=template&id=39816008&scoped=true"
import script from "./HomeContentBlockFlightGorilla.vue?vue&type=script&lang=js"
export * from "./HomeContentBlockFlightGorilla.vue?vue&type=script&lang=js"
import style0 from "./HomeContentBlockFlightGorilla.vue?vue&type=style&index=0&id=39816008&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39816008",
  null
  
)

export default component.exports